import treeimg from "../../../assets/images/Diagram1.png";

function USDMFPage() {
    return (
        <>
            <div className="flex items-center gap-2 mb-12 mt-6">
                <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
                <h3 className="text-lg font-bold text-[#05326D]">
                    US Drug Master File (DMF) Services
                </h3>
            </div>
            <img src={treeimg} alt="USDMF" className="w-full h-auto mb-12 rounded-md" />

            <h4 className="text-md font-bold text-[#05326D] mb-4 mt-8">
                End-to-End Regulatory Support for Seamless FDA Submissions
            </h4>
            <p className="text-[#05326D]">End-to-End Regulatory Support for Seamless FDA Submissions </p>

            <p className="mt-4 mb-4 text-[#05326D]">At FDAC, we specialize in delivering high-quality, compliant, and strategically aligned Drug Master File (DMF)
                submissions to the US FDA. Our team provides comprehensive guidance throughout the documentation and
                submission lifecycle, ensuring your DMF is prepared, published, and filed with precision.</p>

            <hr className="border-t border-gray-300 mb-8" />

            <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    What Is a DMF?
                </span>
            </div>
            <p className="text-[#05326D]"> A Drug Master File (DMF) is a confidential dossier submitted to the US FDA that contains detailed information
                about the manufacturing, processing, packaging, and storage of drug substances or components. It allows
                applicants to reference critical data in their regulatory filings (e.g., NDAs, ANDAs, INDs, BLAs) without disclosing
                proprietary content to third parties. </p>

            <h4 className="text-md font-bold text-[#05326D] mb-4 mt-4">
                Key points:
            </h4>
            <p className="text-[#05326D] mt-4">-  DMFs are not mandatory by regulation but are widely used to support product applications. </p>
            <p className="text-[#05326D] mt-4">-  They are neither approved nor rejected—FDA reviews them only when referenced in an application. </p>
            <p className="text-[#05326D] mt-4"> -  DMFs are structured in CTD format and submitted electronically via eCTD through the FDA ESG portal.</p>

            <div className="flex items-center gap-2 mb-2 mt-8">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    FDAC’s DMF Expertise
                </span>
            </div>

            <p className="mb-4 mt-4 text-[#05326D]">
                We offer tailored solutions for the preparation, publishing, and submission of the following DMF types:
            </p>

            <div className="grid grid-cols-2 gap-2 text-sm">
                <div className="font-semibold text-[#05326D]">DMF Type</div>
                <div className="font-semibold text-[#05326D]">Description</div>

                <div className="font-bold text-[#05326D]">Type II</div>
                <div className="text-[#05326D]">Drug Substance, Intermediates, Semi-Finished Dosage Forms</div>

                <div className="font-bold text-[#05326D]">Type III</div>
                <div className="text-[#05326D]">Packaging Materials</div>

                <div className="font-bold text-[#05326D]">Type IV</div>
                <div className="text-[#05326D]">Excipients, Colorants, Flavors, Essences, and Related Materials</div>
            </div>

            <div className="flex items-center gap-2 mb-4 mt-6">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    DMF Writing & Submission Services
                </span>
            </div>

            <p className="ml-2 mt-2 text-[#05326D]">- DMF Due Diligence & Technical Audits</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Conversion from Paper/CTD to eCTD Format</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Authoring of Modules 1, 2 (QOS in QbR format), and 3</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Customized Module Writing for Type II, III, and IV DMFs</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Publishing in eCTD Format and Submission via ESG</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Query Response Support for ANDA, NDA, BLA References</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Assistance with FDA Requests for Additional Information</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Strategic Support to Overcome Refuse-to-File (RTF) Issues</p>

            <div className="flex items-center gap-2 mb-4 mt-4">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    eCTD Publishing Services
                </span>
            </div>

            <p className="ml-2 mt-2 text-[#05326D]">- eCTD Compilation, QC Review & Technical Validation</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle Management & Baseline Conversion</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Importing/Cloning Existing Applications</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Pre-assigned DMF Number Acquisition</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Annual Updates & Amendments</p>
            <p className="ml-2 mt-2 text-[#05326D]">- PDF Publishing: Bookmarking, Hyperlinking, OCR, Font Embedding</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Compliance with FDA’s Technical Standards</p>

            <div className="flex items-center gap-2 mb-4 mt-4">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    DMF Submission Services
                </span>
            </div>

            <p className="ml-2 mt-2 text-[#05326D]">- Submission of Original DMFs, Amendments, and Annual Reports via FDA ESG </p>
            <p className="ml-2 mt-2 text-[#05326D]">- Full support for query responses and lifecycle updates</p>


            <div className="flex items-center gap-2 mb-4 mt-4">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    US Agent & Drug Listing Services
                </span>
            </div>

            <p className="ml-2 mt-2 text-[#05326D]">- US Agent Representation</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Drug Listing & Establishment Registration (ER)</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Labeler Code Application & NDC Assignment</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Annual ER Updates & Listing Certifications (eDRLS)</p>
            <p className="ml-2 mt-2 text-[#05326D]">- GDUFA Cover Sheet Filing & Self-Identification</p>

            <div className="flex items-center gap-2 mb-4 mt-4">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    DMF Lifecycle Management
                </span>
            </div>

            <p className="ml-2 mt-4 text-[#05326D]">- Preparation and Publishing of Annual Reports</p>
            <p className="ml-2 mt-4 text-[#05326D]">- Filing of Amendments and Full Revisions</p>
            <p className="ml-2 mt-4 text-[#05326D]">- Technical Support for Safe and Compliant Updates</p>
            <p className="ml-2 mt-4 text-[#05326D]">
                At FDAC, we combine regulatory intelligence with operational excellence to ensure your DMF submissions are
                accurate, timely, and strategically positioned for success. Whether you’re filing a new DMF or managing updates,
                our team is committed to delivering results that meet global standards and exceed expectations.</p>


            <hr className="border-t border-gray-300 mb-8 mt-8" />

            <div className="flex items-center gap-2 mb-2 mt-2">
                <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
                <span className="text-[16px] font-bold text-[#05326D]">
                    Why FDAC?
                </span>
            </div>

            <p className="ml-2 text-[#05326D]">As your strategic regulatory partner, FDAC ensures that every DMF submission—whether for APIs, excipients,
                packaging, or intermediates—is meticulously prepared, compliant with regional standards, and positioned for
                timely approval. Our global experience spans: </p>

            <p className="ml-2 mt-2 text-[#05326D]">- DMF authoring and publishing</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle management and updates</p>
            <p className="ml-2 mt-2 text-[#05326D]">- Regulatory intelligence and submission strategy</p>
            <p className="ml-2 mt-2 text-[#05326D]">- End-to-end support across US, EU, WHO, China, and emerging markets</p>
            <p className="ml-2 mt-2 text-[#05326D]">
                With FDAC, you gain more than a service provider—you gain a partner committed to regulatory excellence and
                global success.</p>
        </>

    );
}

export default USDMFPage;
